import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import styles from './Footer.module.css';

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <motion.footer
      className={styles.footer}
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
    >
      <div className={styles.container}>
        <div className={styles.brand}>
          <img src="/favicon.svg" alt="Omen SEO" className={styles.logo} />
          <span className={styles.copyright}>
            © {currentYear} Omen SEO. All rights reserved.
          </span>
        </div>

        <nav className={styles.links}>
          <Link to="/privacy" className={styles.link}>Privacy</Link>
          <Link to="/terms" className={styles.link}>Terms</Link>
          <Link to="/contact" className={styles.link}>Contact</Link>
        </nav>
      </div>
    </motion.footer>
  );
}
